import { TIBBO_DEVICE_ID } from '@appblocks/platforms/PlatformUtils';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    SettingType,
    CodeBlock,
    BlockType,
    Define,
    SettingState,
    SettingOption,
    ValidationMessage,
    ValidationMessageType,
    FeatureType,
} from '@appblocks/codegeneration/types';

export default class CustomFeatures extends BaseFeature {
    constructor() {
        super();
        this.id = 'custom_features';
        this.name = 'Custom Plugins';
        const settings = [
            {
                id: 'FEATURES',
                name: 'Features',
                settingType: SettingType.ARRAY,
                refId: 'custom_feature',
                required: true,
                default: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    validate(): ValidationMessage[] {
        const messages: ValidationMessage[] = [];
        const features = this.getSettingValue('FEATURES');
        const featureIds = features.map((f: any) => f.getSettingValue('FEATURE_ID'));
        for (let i = 0; i < features.length; i++) {
            const feature = features[i];
            const featureId = feature.getSettingValue('FEATURE_ID');
            if (featureIds.filter((id: string) => id === featureId).length > 1) {
                messages.push({
                    featureId: feature.getID(),
                    settingId: 'FEATURE_ID',
                    messageType: ValidationMessageType.ERROR,
                    message: `Feature ID ${featureId} is not unique`,
                });
            }
        }
        return messages;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];
        return blocks;
    }
}
